import { render, staticRenderFns } from "./usageHistory.vue?vue&type=template&id=4530a49a&scoped=true&"
import script from "./usageHistory.vue?vue&type=script&lang=js&"
export * from "./usageHistory.vue?vue&type=script&lang=js&"
import style0 from "./usageHistory.vue?vue&type=style&index=0&id=4530a49a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4530a49a",
  null
  
)

export default component.exports